import { Chip } from '@mui/material'
import { styles } from './styles'
import type { CompanyStatusProps } from './types'
import { CompanyStatus as Status } from '@/api/models/company'

export const BankStatus = ({ status }: CompanyStatusProps) => {
  if (status) {
    switch (status) {
      case Status.CONFIRMED:
        return (
          <Chip
            sx={styles.chip}
            variant={'outlined'}
            color="success"
            label={'Действует'}
          />
        )
      case Status.DRAFT:
        return (
          <Chip
            sx={{
              ...styles.chip,
              color: '#787878',
              borderColor: '#8E8E8E',
              backgroundColor: '#EEEEEE',
            }}
            variant={'outlined'}
            label={'Черновик'}
          />
        )
      case 'DELETED':
        return (
          <Chip
            sx={styles.chip}
            variant={'outlined'}
            color="error"
            label={'Удалён'}
          />
        )
      default:
        return (
          <Chip
            sx={styles.chip}
            variant={'outlined'}
            color="primary"
            label={'...'}
          />
        )
    }
  }
}
